import 'babel-polyfill';

const initialStateText = document.querySelector('#initialState').innerText;
const initialState = eval(`(${initialStateText})`);

import { Provider } from 'preact-redux';
import Application from '../components/Application';
// import createStore from '../store';

// import { createStore } from 'redux';
// const store = createStore(state => state, initialState);
// const store = createStore(initialState.pages);

import setupStore from '../store';
const store = setupStore(initialState.pages);

import { h, render } from 'preact';

import '../components/main.scss';

const serverAppDiv = document.querySelector('#app');
render(<Provider store={store}><Application /></Provider>, serverAppDiv, serverAppDiv.lastElementChild);



// WEBPACK FOOTER //
// ./src/client/index.js